// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1bx8I","col":"styles_col__KcXhR","fulfillmentStatus":"styles_fulfillmentStatus__3dzSG","emailCol":"styles_emailCol__1lRCi"};